//Please add the language resource
const orderSearch = {
  projectCode: 'projectCode',
  projectName: 'projectName',
  transTypeName:'TransTypeName',
  originAddrCode:'originAddrCode',
  originAddrName:'originAddrName',
  originAddrContactMan:'originAddrContactMan',
  originAddrContactTel:'originAddrContactTel',
  originAddrProvinceName:'originAddrProvinceName',
  originAddrCityName:'originAddrCityName',
  originAddrDistrictName:'originAddrDistrictName',
  originAddrLocation:'originAddrLocation',
  originAddrLongitude:'originAddrLongitude',
  originAddrLatitude:'originAddrLatitude',

  destAddrCode:'destAddrCode',
  destAddrName:'destAddrName',
  destAddrContactMan:'destAddrContactMan',
  destAddrContactTel:'destAddrContactTel',
  destAddrProvinceName:'destAddrProvinceName',
  destAddrCityName:'destAddrCityName',
  destAddrDistrictName:'destAddrDistrictName',
  destAddrLocation:'destAddrLocation',
  destAddrLatitude:'destAddrLatitude',
  destAddrLongitude:'destAddrLongitude',

  totalVolume:'TotalVolume',
  shipperCode:'ShipperCode',
  orderType:'OrderType',
  createTime:'CreateTime',
  totalQty:'TotalQty',
  orderClassify: 'orderClassify',
  reqDispatchDate:'reqDispatchDate',
  companyName:'CompanyName',
  soOrSto:'SoOrSto',
  shipperName:'ShipperName',
  totalNetWeight:'TotalNetWeight',
  sendStreet:'SendStreet',
  orderStatusName:'orderStatusName',
  orderNo:'orderNo',
  totalWeight:'TotalWeight',
  updater:'Updater',
  customerOrderNo:'customerOrderNo',
  updateTime:'UpdateTime',
  waybillNo:'WaybillNo',
  companyCode:'CompanyCode',
  carrierName:'CarrierName',
  orderStatusNo:'orderStatusNo',
  creator:'Creator',
  transTypeNo:'TransTypeNo',
  orderDate:'OrderDate',
  receiveStreet:'ReceiveStreet',
  orderSource:'OrderSource',
  reqArriverDate:'ReqArriverDate',
  carrierNo:'CarrierNo',
  urgentFlag: 'urgentFlag',
  orderProperty: 'orderProperty',
  basic: {
    gpsFetchSource: 'GPS Fetch Source',
  },
  transport: {
    planNo: 'Plan No',
    carrierName: 'Carrier Name',
    truckNo: 'Truck No',
    truckTypeName: 'Truck Type',
    driverName: 'Driver Name',
    driverTel: 'Driver Tel',
  },
  msg: {}
};
export default orderSearch




// WEBPACK FOOTER //
// ./src/page/order/orderSearch/lang/orderSearch.en.js